module.exports = __webpack_public_path__ + "b7259e150afcac046b3ae75dfd093b9c.png";